export default function cleanLocalStorage(
  keys = [
    'preparationOrdersFilters',
    'shipmentsFilters',
    'manifestsFilters',
    'usersFilters',
    'ordersFilters',
    'uploadFileTypeWarning',
    'retryShipmentsFilters',
    'marketplacePendingOrdersFilters',
  ],
) {
  keys.forEach((key) => localStorage.removeItem(key));
}
